import { Stack, Typography } from '@sureco/design-system'
import ContentSection from 'layouts/ContentSection/ContentSection'
import React from 'react'
import useCustomerConfiguration from '../../hooks/useCustomerConfiguration'
import CustomPayrollConfigurationForm from './component/CustomPayrollConfigurationForm/CustomPayrollConfigurationForm'
import HrisRules from './component/HrisRules/HrisRules'
import IntegrationForm from './component/IntegrationForm/IntegrationForm'
import MedicareColumnsForm from './component/MedicareColumnsForm/MedicareColumnsForm'
import PayrollList from './component/PayrollList'
import RowSection from './component/RowSection'
import useHrisPayroll from './hooks/useHrisPayroll'

export default function HrisPayrollTab({
  id,
  companyName,
}: {
  id: string
  companyName?: string
}) {
  const { updateCensusApiVersionMutation } = useCustomerConfiguration(
    id,
    companyName
  )
  const {
    data,
    isLoading,
    updateHrisIntegration,
    updateMedicareColumns,
    updateCustomPayrollConfiguration,
    isUpdatingHrisIntegration,
  } = useHrisPayroll(id, companyName)
  const {
    mutate: updateCensusApiVersion,
    isPending: isUpdatingCensusApiVersion,
  } = updateCensusApiVersionMutation()
  const censusApiVersion = data?.isCMv2APIEnabled ? 'v2' : 'v1'

  return (
    <Stack>
      <ContentSection title="HRIS" loading={isLoading}>
        <Stack space={20}>
          <RowSection title="API Integration">
            <Stack>
              <IntegrationForm
                initialValues={{
                  ...data,
                }}
                censusApiVersion={censusApiVersion}
                isCensusApiVersionDisabled={isLoading}
                isUpdatingCensusApiVersion={isUpdatingCensusApiVersion}
                onCensusApiVersionChange={(version) => {
                  updateCensusApiVersion({ version })
                }}
                isUpdatingHrisIntegration={isUpdatingHrisIntegration}
                onFormSubmit={updateHrisIntegration}
              />
            </Stack>
          </RowSection>
          <RowSection title="Eligibility Rules">
            {data?.eligibilityRules?.length > 0 ? (
              <HrisRules rule={data?.eligibilityRules} />
            ) : (
              <Typography size={14} color="#999">
                No eligibility rules set
              </Typography>
            )}
          </RowSection>
          <MedicareColumnsForm
            medicareEmployeeSign={data?.medicareEmployeeSign}
            medicareEmployerSign={data?.medicareEmployerSign}
            isMedicarePerColumnEnabled={Boolean(
              data?.isMedicarePerColumnEnabled
            )}
            isSaving={isUpdatingHrisIntegration}
            onFormSubmit={updateMedicareColumns}
          />
          <CustomPayrollConfigurationForm
            customReportUploadHris={data?.customReportUploadHris}
            customReportHistoryDisplay={data?.customReportHistoryDisplay}
            isCustomPayrollConfigurationEnabled={Boolean(
              data?.isCustomPayrollConfigurationEnabled
            )}
            isSaving={isUpdatingHrisIntegration}
            onFormSubmit={updateCustomPayrollConfiguration}
          />
          <RowSection title="Payroll History">
            <Stack>
              <Typography size={14}>
                Download the most recent payroll deductions in CSV format.
              </Typography>
              <PayrollList list={data?.payrollHistory} />
            </Stack>
          </RowSection>
          <RowSection title="Excluded Benefits" />
        </Stack>
      </ContentSection>
    </Stack>
  )
}
